var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"p-2",attrs:{"show":_vm.isShow,"variant":_vm.alertVariant}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.alertText)}}),_c('b-button',{staticClass:"mt-2 mr-1",attrs:{"variant":_vm.buttonVariant},on:{"click":function($event){return _vm.$router.push({name: _vm.routeName})}}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }